import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "More", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "pt-3 pb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabComponent = _resolveComponent("TabComponent")!
  const _component_ExpandIcon = _resolveComponent("ExpandIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        ref: "containerEl",
        class: _normalizeClass(["relative z-10 flex items-center w-full", {
          'justify-center': _ctx.centred,
          'justify-start': !_ctx.centred,
        }])
      }, [
        _renderSlot(_ctx.$slots, "before-tabs"),
        (_ctx.tabs)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.firstTab)
                ? (_openBlock(), _createBlock(_component_TabComponent, {
                    id: `tab-${_ctx.firstTab.slug}`,
                    key: _ctx.firstTab.slug,
                    slug: _ctx.firstTab.slug,
                    "tab-type": _ctx.tabType
                  }, {
                    default: _withCtx(() => [
                      (_ctx.firstTab.route)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _ctx.firstTab.route
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.firstTab.label), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.firstTab.label), 1))
                    ]),
                    _: 1
                  }, 8, ["id", "slug", "tab-type"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabLinks, (tab) => {
                return (_openBlock(), _createBlock(_component_TabComponent, {
                  id: `tab-${tab.slug}`,
                  key: tab.slug,
                  slug: tab.slug,
                  "tab-type": _ctx.tabType
                }, {
                  default: _withCtx(() => [
                    (tab.route)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: tab.route
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(tab.label), 1))
                  ]),
                  _: 2
                }, 1032, ["id", "slug", "tab-type"]))
              }), 128)),
              (_ctx.menuLinks.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ml-auto mt-1 py-1 pl-4 flex items-center text-sm sm:text-base transition text-cebai-grey-dark hover:text-cebai-primary",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
                  }, [
                    _hoisted_4,
                    _createVNode(_component_ExpandIcon, { class: "ml-2 mt-0.5 stroke-current stroke-2" })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _renderSlot(_ctx.$slots, "tabs", { key: 1 }),
        _renderSlot(_ctx.$slots, "after-tabs")
      ], 2),
      (_ctx.tabs && _ctx.menuLinks.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["absolute z-20 right-0 top-full -mt-2 px-3 py-2 flex flex-col items-start bg-cebai-base-light rounded-md shadow-[0_0_20px_0_rgba(51,51,51,0.1)]", { hidden: !_ctx.isMenuOpen }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuLinks, (menuItem) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: menuItem.slug
              }, [
                (menuItem !== _ctx.firstTab)
                  ? (_openBlock(), _createBlock(_component_TabComponent, {
                      key: 0,
                      slug: menuItem.slug,
                      "tab-type": null
                    }, {
                      default: _withCtx(() => [
                        (menuItem.route)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: menuItem.route
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(menuItem.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(menuItem.label), 1))
                      ]),
                      _: 2
                    }, 1032, ["slug"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "between-tabs")
    ]),
    (_ctx.hasContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "tab-content")
        ]))
      : _createCommentVNode("", true)
  ]))
}